import { createContext } from "react"
import { DefaultDoctorInterface, DoctorInterface } from "../../../types"

export interface DataRegistrationFormInterface {
  RegNo: string, setRegNo: (RegNo: string) => void,
  fullName: string, setFullName: (fullName: string) => void,
  yearOfBirth: string, setYearOfBirth: (yearOfBirth: string) => void,
  placeOfBirth: string, setPlaceOfBirth: (placeOfBirth: string) => void,
  sex: string, setSex: (sex: string) => void,
  telephone: string, setTelephone: (telephone: string) => void,
  whatsapp: string, setWhatsapp: (whatsapp: string) => void,
  email: string, setEmail: (email: string) => void,
  // nationality: string, setNationality: (nationality: string) => void,
  current: string, setCurrent: (current: string) => void,
  origin: string, setOrigin: (origin: string) => void,
  medecinType: any, setMedecinType: (medecinType: any) => void,
  inscriptionDate: string, setInscriptionDate: (inscriptionDate: string) => void,
  avatar: File | any, setAvatar: (avatar: File | any) => void,
  password: string, setPassword: (password: string) => void,
  speciality: string, setSpeciality: (speciality: string) => void,
  cabinet: any, setCabinet: (cabinet: any) => void,

  practiceLocations: string, setPracticeLocations: (practiceLocations: string) => void,
  maritalStatus: string, setMaritalStatus: (maritalStatus: string) => void,
  // conjoint: any, setConjoint: (conjoint: any) => void,
  conjointDateOfBirth: string, setConjointDateOfBirth: (yearOfBirth: string) => void,
  conjointPlaceOfBirth: string, setConjointPlaceOfBirth: (placeOfBirth: string) => void,
  conjointProfession: string, setConjointProfession: (profession: string) => void,
  num_Child: string, setNumChild: (num_Child: string) => void,
  militarySituation: string, setMilitarySituation: (militarySituation: string) => void,
  highSchoolAccomplishments: string, setHighSchoolAccomplishments: (highSchoolAccomplishments: string) => void,
  educationalAchievements: string, setEducationalAchievements: (educationalAchievements: string) => void,
  dentalSchoolInformation: string, setDentalSchoolInformation: (dentalSchoolInformation: string) => void,
  // 15
  period: string, setPeriod: (period: string) => void,
  yearsOfSuccessfulStudy: string, setYearsOfSuccessfulStudy: (yearsOfSuccessfulStudy: string) => void,
  dateOfGraduation: string, setDateOfGraduation: (dateOfGraduation: string) => void,
  placeOfGraduation: string, setPlaceOfGraduation: (placeOfGraduation: string) => void,
  type: string, setType: (type: string) => void,

  // 16
  universityHospitalTitles: string, setUniversityHospitalTitles: (universityHospitalTitles: string) => void,
  // 17
  advancedQualifications: string, setAdvancedQualifications: (advancedQualifications: string) => void, 
  // 18
  specialtyQualificationStatus: string, setSpecialtyQualificationStatus: (specialtyQualificationStatus: string) => void, 
  // 19
  supplementaryUniversityCertifications: string, setSupplementaryUniversityCertifications: (supplementaryUniversityCertifications: string) => void,
  // 20
  distinctionsAndHonoraryTitles: string, setDistinctionsAndHonoraryTitles: (distinctionsAndHonoraryTitles: string) => void,
  // 21
  otherUniversityDegrees: string, setOtherUniversityDegrees: (otherUniversityDegrees: string) => void, 
  // 22
  specialtyCertificateInProgress: string, setSpecialtyCertificateInProgress: (specialtyCertificateInProgress: string) => void,

  publicServiceOrMilitaryRecruitment: string, setPublicServiceOrMilitaryRecruitment: (publicServiceOrMilitaryRecruitment: string) => void,
  privateSectorEmploymentInMauritania: string, setPrivateSectorEmploymentInMauritania: (privateSectorEmploymentInMauritania: string) => void,
  foreignProfessionalPracticeInMauritania: string, setForeignProfessionalPracticeInMauritania: (foreignProfessionalPracticeInMauritania: string) => void,

  modeOfExercise: string, setModeOfExercise: (modeOfExercise: string) => void,
  salaryType: string, setSalaryType: (salaryType: string) => void,
  employerName: string, setEmployerName: (employerName: string) => void,

  status: string, setStatus: (status: string) => void,
  country: string, setCountry: (country: string) => void,

  workInPublicSector: string, setWorkInPublicSector: (workInPublicSector: string) => void,
  practiceInPrivateMedicine: string, setPracticeInPrivateMedicine: (practiceInPrivateMedicine: string) => void,
  privatePracticeAuthorization: string, setPrivatePracticeAuthorization: (privatePracticeAuthorization: string) => void,
  workPracticeIn: string, setWorkPracticeIn: (workPracticeIn: string) => void,
  remplacements: string, setRemplacements: (remplacements: string) => void,
  practiceHealthcareDiagnosis: string, setPracticeHealthcareDiagnosis: (practiceHealthcareDiagnosis: string) => void,
  siNon: string, setSiNon: (siNon: string) => void,
  activityMedicine: string | boolean, setActivityMedicine: (activityMedicine: string | boolean) => void,
  paramedical: string | boolean, setParamedical: (paramedical: string | boolean) => void,
  otherActivities: string, setOtherActivities: (otherActivities: string) => void,
  association: string | boolean, setAssociation: (association: string | boolean) => void,
  interestInOrganizations: string | boolean, setInterestInOrganizations: (interestInOrganizations: string | boolean) => void,
  contract: string, setContract: (contract: string) => void,
  contractCommunicationCompliance: string, setContractCommunicationCompliance: (contractCommunicationCompliance: string) => void,
  organizationsSeekingCollaboration: string | boolean, setOrganizationsSeekingCollaboration: (organizationsSeekingCollaboration: string | boolean) => void,
  languages: string | boolean, setLanguages: (languages: string | boolean) => void,
  refusedRegistration: string | boolean, setRefusedRegistration: (refusedRegistration: string | boolean) => void,
  regOrderList: string | boolean, setRegOrderList: (regOrderList: string | boolean) => void,
  otherCountries: string | boolean, setOtherCountries: (otherCountries: string | boolean) => void,
  jurisdictionalPenalties: string | boolean, setJurisdictionalPenalties: (jurisdictionalPenalties: string | boolean) => void,
  criminalCivilConvictions: string | boolean, setCriminalCivilConvictions: (criminalCivilConvictions: string | boolean) => void,
  judicialDisciplinaryActions: string | boolean, setJudicialDisciplinaryActions: (judicialDisciplinaryActions: string | boolean) => void,

  doctorOptions: any, setDoctorOptions: (doctorOptions: any) => void,

}

export const DataDefaultRegistrationFormInterface: DataRegistrationFormInterface = {
  RegNo: "", setRegNo: () => {},
  fullName: "", setFullName: () => {},
  yearOfBirth: "", setYearOfBirth: () => {},
  placeOfBirth: "", setPlaceOfBirth: () => {},
  sex: "", setSex: () => {},
  telephone: "", setTelephone: () => {},
  whatsapp: "", setWhatsapp: () => {},
  email: "", setEmail: () => {},
  current: "", setCurrent: () => {},
  medecinType: null, setMedecinType: () => {},
  origin: "", setOrigin: () => {},
  inscriptionDate: "", setInscriptionDate: () => {},
  avatar: null, setAvatar: () => {},
  password: "", setPassword: () => {},
  speciality: "", setSpeciality: () => {},
  cabinet: null, setCabinet: () => {},

  practiceLocations: "", setPracticeLocations: () => {},
  maritalStatus: "", setMaritalStatus: () => {},
  // conjoint: null, setConjoint: () => {},
  conjointDateOfBirth: "", setConjointDateOfBirth: () => {},
  conjointPlaceOfBirth: "", setConjointPlaceOfBirth: () => {},
  conjointProfession: "", setConjointProfession: () => {},
  
  num_Child: "", setNumChild: () => {},
  militarySituation: "", setMilitarySituation: () => {},
  highSchoolAccomplishments: "", setHighSchoolAccomplishments: () => {},
  educationalAchievements: "", setEducationalAchievements: () => {},
  dentalSchoolInformation: "", setDentalSchoolInformation: () => {},
  
  // 15
  period: "", setPeriod: () => {},
  yearsOfSuccessfulStudy: "", setYearsOfSuccessfulStudy: () => {},
  dateOfGraduation: "", setDateOfGraduation: () => {},
  placeOfGraduation: "", setPlaceOfGraduation: () => {},
  type: "", setType: () => {},
  // 16
  universityHospitalTitles: "", setUniversityHospitalTitles: () => {},
  // 17
  advancedQualifications: "", setAdvancedQualifications: () => {}, 
  // 18
  specialtyQualificationStatus: "", setSpecialtyQualificationStatus: () => {}, 
    // 19
  supplementaryUniversityCertifications: "", setSupplementaryUniversityCertifications: () => {},
  // 20
  distinctionsAndHonoraryTitles: "", setDistinctionsAndHonoraryTitles: () => {},
  // 21
  otherUniversityDegrees: "", setOtherUniversityDegrees: () => {}, 
  // 22 
  specialtyCertificateInProgress: "", setSpecialtyCertificateInProgress: () => {},

  publicServiceOrMilitaryRecruitment: "", setPublicServiceOrMilitaryRecruitment: () => {},
  privateSectorEmploymentInMauritania: "", setPrivateSectorEmploymentInMauritania: () => {},
  foreignProfessionalPracticeInMauritania: "", setForeignProfessionalPracticeInMauritania: () => {},

  modeOfExercise: "", setModeOfExercise: () => {},
  salaryType: "", setSalaryType: () => {},
  employerName: "", setEmployerName: () => {},

  status: "", setStatus: () => {},
  country: "", setCountry: () => {},

  workInPublicSector: "", setWorkInPublicSector: () => {},
  practiceInPrivateMedicine: "", setPracticeInPrivateMedicine: () => {},
  privatePracticeAuthorization: "", setPrivatePracticeAuthorization: () => {},
  workPracticeIn: "", setWorkPracticeIn: () => {},
  remplacements: "", setRemplacements: () => {},
  practiceHealthcareDiagnosis: "", setPracticeHealthcareDiagnosis: () => {},
  siNon: "", setSiNon: () => {},
  activityMedicine: false, setActivityMedicine: () => {},
  paramedical: false, setParamedical: () => {},
  otherActivities: "", setOtherActivities: () => {},
  association: false, setAssociation: () => {},
  interestInOrganizations: false, setInterestInOrganizations: () => {},
  contract: "", setContract: () => {},
  contractCommunicationCompliance: "", setContractCommunicationCompliance: () => {},
  organizationsSeekingCollaboration: false, setOrganizationsSeekingCollaboration: () => {},
  languages: false, setLanguages: () => {},
  refusedRegistration: false, setRefusedRegistration: () => {},
  regOrderList: false, setRegOrderList: () => {},
  otherCountries: false, setOtherCountries: () => {},
  jurisdictionalPenalties: false, setJurisdictionalPenalties: () => {},
  criminalCivilConvictions: false, setCriminalCivilConvictions: () => {},
  judicialDisciplinaryActions: false, setJudicialDisciplinaryActions: () => {},

  doctorOptions: null, setDoctorOptions: () => {},

}


export const RegistrationFormContext = createContext<DataRegistrationFormInterface>(DataDefaultRegistrationFormInterface)

export interface RegistrationForm {
  _id: any,
  doctor: DoctorInterface,
  practiceLocations: string
  maritalStatus: string
  conjoint: {
    dateOfBirth: string,
    placeOfBirth: string,
    profession: string,
  },
  num_Child: string
  militarySituation: string
  highSchoolAccomplishments: string
  educationalAchievements: string
  dentalSchoolInformation: string
  // 15
  dentalMedicineDegree: {
    period: string
    yearsOfSuccessfulStudy: string
    dateOfGraduation: string
    placeOfGraduation: string
    type: string
  }

  // 16
  universityHospitalTitles: string
  // 17
  advancedQualifications: string
  // 18
  specialtyQualificationStatus: string
  // 19
  supplementaryUniversityCertifications: string
  // 20
  distinctionsAndHonoraryTitles: string
  // 21
  otherUniversityDegrees: string
  // 22
  specialtyCertificateInProgress: string

  specificDateInformation: {
    publicServiceOrMilitaryRecruitment: string
    privateSectorEmploymentInMauritania: string
    foreignProfessionalPracticeInMauritania: string
  },
  modeOfExercise: string
  salariedMedicalPractitioner: {
    salaryType: string
    employerName: string
  },

  foreignDoctor: {
    status: string
    country: string
  },

  workInPublicSector: string
  practiceInPrivateMedicine: string
  privatePracticeAuthorization: string
  workPracticeIn: string
  remplacements: string
  practiceHealthcareDiagnosis: string
  siNon: string
  activityMedicine: string
  paramedical: string
  otherActivities: string
  association: string
  interestInOrganizations: string
  contract: string
  contractCommunicationCompliance: string
  organizationsSeekingCollaboration: string
  languages: string
  refusedRegistration: string
  regOrderList: string
  otherCountries: string
  jurisdictionalPenalties: string
  criminalCivilConvictions: string
  judicialDisciplinaryActions: string
}

export const DefaultRegistrationForm: RegistrationForm = {
  _id: "",
  doctor: DefaultDoctorInterface,
  practiceLocations: "",
  maritalStatus: "",
  conjoint: {
    dateOfBirth: "",
    placeOfBirth: "",
    profession: "",
  },
  num_Child: "",
  militarySituation: "",
  highSchoolAccomplishments: "",
  educationalAchievements: "",
  dentalSchoolInformation: "",
  // 15
  dentalMedicineDegree: {
    period: "",
    yearsOfSuccessfulStudy: "",
    dateOfGraduation: "",
    placeOfGraduation: "",
    type: "",
  },

  // 16
  universityHospitalTitles: "",
  // 17
  advancedQualifications: "",
  // 18
  specialtyQualificationStatus: "",
  // 19
  supplementaryUniversityCertifications: "",
  // 20
  distinctionsAndHonoraryTitles: "",
  // 21
  otherUniversityDegrees: "",
  // 22
  specialtyCertificateInProgress: "",

  specificDateInformation: {
    publicServiceOrMilitaryRecruitment: "",
    privateSectorEmploymentInMauritania: "",
    foreignProfessionalPracticeInMauritania: "",
  },

  modeOfExercise: "",
  
  salariedMedicalPractitioner: {
    salaryType: "",
    employerName: "",
  },
  foreignDoctor: {
    status: "",
    country: "",
  },

  workInPublicSector: "",
  practiceInPrivateMedicine: "",
  privatePracticeAuthorization: "",
  workPracticeIn: "",
  remplacements: "",
  practiceHealthcareDiagnosis: "",
  siNon: "",
  activityMedicine: "",
  paramedical: "",
  otherActivities: "",
  association: "",
  interestInOrganizations: "",
  contract: "",
  contractCommunicationCompliance: "",
  organizationsSeekingCollaboration: "",
  languages: "",
  refusedRegistration: "",
  regOrderList: "",
  otherCountries: "",
  jurisdictionalPenalties: "",
  criminalCivilConvictions: "",
  judicialDisciplinaryActions: "",
}

